import { goJoinEvent } from "@/lobby_common/utils/utils.js";
import { predictedEvents } from "@/lobby_common/api/basic_gen.js";
export default {
  name: "mode2",
  components: {},
  data() {
    return {
      slides: [],
      listPc: [],
      listH5: [],
      isShowBtn: false,
    };
  },
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  filters: {
    time1(time) {
      if (!time) return "";
      var date = new Date(Number(time * 1000)); // 初始化日期
      var year = date.getFullYear(); // 获取月份
      var month = date.getMonth() + 1; // 获取月份
      var day = date.getDate(); // 获取具体日
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      return day + " / " + month + " / " + year;
    },
    time2(time) {
      if (!time) return "";
      var date = new Date(Number(time * 1000)); // 初始化日期
      var hour = date.getHours(); // 获取时
      var minutes = date.getMinutes(); // 获取分
      hour = hour < 10 ? "0" + hour : hour;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      return hour + " : " + minutes;
    },
  },
  computed: {
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    list() {
      return this.IsMobile ? this.listH5 : this.listPc;
    },
    lang() {
      return this.$store.getters.getLang;
    },
  },
  watch: {},
  async created() {
    this.predictedEventsFun()
  },
  mounted() {
  },
  methods: {
    async predictedEventsFun() {
      const { code, data } = await predictedEvents({
        clientType: this.IsMobile ? 'h5' : 'pc'
      });
      if (code === 0) {
        const arr = data?.list || []
        this.slides = [ ...arr ]
        this.listPc = arr.slice(0, 2)
        this.listH5 = [ ...arr ]
        this.isShowBtn = this.slides.length > 2
      }
    },
    getTxt(opt, num) {
      let txt = opt.matchRecord?.firstTeamHistoryMatchScore || ''
      let arr = txt.split(',')
      return arr[num] || ''
    },
    getTxtPadding(opt, num) {
      let txt = opt.matchRecord?.firstTeamHistoryMatchScore || ''
      let arr = txt.split(',')
      let txt1 = arr[num] || ''
      let arr1 = txt1.trimStart().split(' ')
      let num1 = arr1[0] || 0
      return num1
    },
    loadMore() {
      this.listPc = [ ...this.slides ]
      this.isShowBtn = false
    },
    toGame() {
      const jump = {
        type: "Jump_TYPE_GAME",
        game: {
          gameGroupSid: this.item.list[0]?.jump?.game?.gameGroupSid,
        },
      };
      goJoinEvent(jump);
    }
  },
};
